import photo1 from "./photos/download.png";
import photo2 from "./photos/photo2.png";
import photo3 from "./photos/download3.png";

export const skills = [
    {
        id:1,
        skill:"HTML"
    },
    {
        id:2,
        skill:"CSS"
    },
    {
        id:3,
        skill:"JavaScript"
    },
    {
        id:4,
        skill:"Python"
    },
    {
        id:5,
        skill:"SQL"
    },
    {
        id:6,
        skill:"PHP"
    },
    {
        id:7,
        skill:"React"
    },
    {
        id:8,
        skill:"Tailwind CSS"
    },
    {
        id:9,
        skill:"REST APIs"
    },
    {
        id:10,
        skill:"JSON"
    },
    {
        id:11,
        skill:"Bootstrap"
    },
    {
        id:12,
        skill:"Git & GitHub"
    },
];
export const projects = [
    {
        id: 1,
        title: "Software Developer",
        subtitle: "(Aug 2021 - Feb 2024) Toronto, Canada",
        description: "1. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec scelerisque nulla ut finibus lacinia. Aenean cursus ultricies metus et tristique.\n2.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec scelerisque nulla ut finibus lacinia. Aenean cursus ultricies metus et tristique. \n3. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec scelerisque nulla ut finibus lacinia. Aenean cursus ultricies metus et tristique.\n4. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec scelerisque nulla ut finibus lacinia. Aenean cursus ultricies metus et tristique.",
        image: photo3,
    },
    {
        id: 2,
        title: "Content Moderator",
        subtitle: "(Mar 2021 - Aug 2021) Waterloo, Canada",
        description: "1. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec scelerisque nulla ut finibus lacinia. Aenean cursus ultricies metus et tristique.\n2.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec scelerisque nulla ut finibus lacinia. Aenean cursus ultricies metus et tristique. \n3. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec scelerisque nulla ut finibus lacinia. Aenean cursus ultricies metus et tristique.\n4. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec scelerisque nulla ut finibus lacinia. Aenean cursus ultricies metus et tristique.",
        image: photo2,
    },
    {
        id: 3,
        title: "Software Engineer",
        subtitle: "(Apr 2018 - Aug 2019) Kerala, India",
        description: "1. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec scelerisque nulla ut finibus lacinia. Aenean cursus ultricies metus et tristique.\n2.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec scelerisque nulla ut finibus lacinia. Aenean cursus ultricies metus et tristique. \n3. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec scelerisque nulla ut finibus lacinia. Aenean cursus ultricies metus et tristique.\n4. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec scelerisque nulla ut finibus lacinia. Aenean cursus ultricies metus et tristique.",
        image: photo1
    }
 
];